import React, { useRef } from "react";
import { createLogger } from "debug/DebugingLogger";
import { PaddleFrameDialog } from "components/main/organizations/PaddleFrameDialog";
import { openCardForm } from "@/lib/paddle";

const log = createLogger("CardFormDialog");

export const CardFormDialog: React.FC<{
  /// `null` when no card is being changed; a new id opens a new form.
  transactionId: string | null;
  onClose: () => void;
  /// The card landed; the webhook confirms it separately.
  onCompleted: () => void;
  /// The reveal wait is over, however it ended.
  onSettled: () => void;
}> = ({ transactionId, onClose, onCompleted, onSettled }) => {
  // Paddle fires this long after the frame opened, so it is read through a ref.
  const completed = useRef(onCompleted);
  completed.current = onCompleted;

  return (
    <PaddleFrameDialog
      openKey={transactionId}
      title="Update card"
      failureText="The card form could not be opened. Close this and try again."
      onClose={onClose}
      onSettled={onSettled}
      openFrame={(settle) =>
        transactionId === null
          ? Promise.resolve()
          : openCardForm({
              transactionId,
              onLoaded: settle,
              onCompleted: () => completed.current(),
            })
      }
      onOpenFailed={(e) => log.error("card form failed to open", e)}
    />
  );
};
